<p-select
  name="treatment"
  [appendTo]="'body'"
  [placeholder]="this.placeholder | translate"
  [(ngModel)]="this.selected"
  [options]="this.treatments"
  [filter]="true"
  [appendTo]="'body'"
  optionLabel="name"
  (onChange)="this.onSelect(this.selected)"
  size="small"
  [showClear]="true"
  (onClear)="this.onSelect(undefined)"
  fluid
></p-select>
